module.exports = __webpack_public_path__ + "img/candidate-choise.99f823c8.svg";